import { render, staticRenderFns } from "./allocateResources.vue?vue&type=template&id=37599fc8&scoped=true&"
import script from "./allocateResources.vue?vue&type=script&lang=js&"
export * from "./allocateResources.vue?vue&type=script&lang=js&"
import style0 from "./allocateResources.vue?vue&type=style&index=0&id=37599fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37599fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37599fc8')) {
      api.createRecord('37599fc8', component.options)
    } else {
      api.reload('37599fc8', component.options)
    }
    module.hot.accept("./allocateResources.vue?vue&type=template&id=37599fc8&scoped=true&", function () {
      api.rerender('37599fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/batchAddFriends/components/allocateResources.vue"
export default component.exports